var BlockView = require('views/block/base-block-view');
var ForgeService = require('services/forge-service');

import EnrollmentDataService from 'services/enrollment-data-service';
import LearnerProfileService from 'services/learner-profile-service';
import {
  LocalStorageService,
  SessionStorageService
} from 'services/web-storage-service';

// # Switch Block
//
//  This block takes (in this example) an enrollment service key and display a set of blocks depending on that value; posible values 'hpdc', 'lpdi' or default
// Content Attributes expected:
// * enrollment_data_property: enrollment service key
// * auto_refresh: enable refreshing right after completing the page
// * hpdc: array of blocks that are to be rendered if the returned value from enrollment service is hpdc
// * lpdi: array of blocks that are to be rendered if the returned value from enrollment service is lpdi
// * default: array of blocks that are to be rendered if the returned value from enrollment service doesn't match 'hpcd' nor 'lpdi'
//
// Should look something like this:
//  - type: switch
//    source:
//      service: enrollment
//      key: 'locale:namespace:prefix'
//    hpdc:
//      blocks:
//        - type: text
//          items:
//            - description: value1
//    lpdi:
//      blocks:
//        - type: text
//          items:
//            - description: value2
//    defaultBlocks:
//      blocks:
//        - type: text
//          items:
//            - description: defaultValue
var SwitchView = BlockView.extend({
  className: 'switch-container',
  services: {
    enrollment: EnrollmentDataService,
    learnerProfile: LearnerProfileService,
    local: LocalStorageService,
    session: SessionStorageService,
  },
  initialize: function() {
    BlockView.prototype.initialize.apply(this, arguments);
    if(this.model.has('enrollment_data_property')) {
      this.model.set('source', { service: 'enrollment', key: this.model.get('enrollment_data_property') });
    }
    if(this.model.get('auto_refresh')) {
      const source = this.model.get('source');
      if(source && source.key) {
        Chaplin.mediator.subscribe(`enrollment-data-saved:${source.key}`, this.render, this);
      }
    }
  },
  render: function() {
    BlockView.prototype.render.apply(this, arguments);
    const source = this.model.get('source');
    const defaults = this.model.get('defaultBlocks');
    let renderBlocks;

    if(defaults && defaults.blocks) {
      renderBlocks = defaults.blocks;
    }
    if(source && source.service && source.key) {
      if(this.services.hasOwnProperty(source.service)) {
        const blocksKey = this.services[source.service].getByDotString(source.key);
        const match = this.model.get(blocksKey);
        if(match && match.blocks) {
          renderBlocks = match.blocks;
        }
      }
    }

    if(renderBlocks) {
      this.renderNestedBlocks(`${this.model.get('cid')}-switch-blocks`, renderBlocks);
    } else {
      console.warn('There was no match nor default blocks to display.');
    }

    // update Forge controls for child blocks
    requestAnimationFrame(() => {
      ForgeService.applyForgeControls(`div[data-region="${this.model.get('cid')}-switch-blocks"]`);
    });
  },

  play: function() {
    this.readyToGo();
  },
  unload: function() {
    if(this.model.get('auto_refresh')) {
      const source = this.model.get('source');
      if(source.key) {
        Chaplin.mediator.unsubscribe(`enrollment-data-saved:${source.key}`, this.render);
      }
    }
  },
});

module.exports = SwitchView;
